import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { Button, Form, Row, Col, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { GruposService, VehiculosService, AlertaService } from '../../../services/apiService';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { sortBy } from "underscore";

import { MultiSelect } from 'primereact/multiselect';
import '../../../styles/global.css'
import "primereact/resources/themes/lara-light-blue/theme.css";
import { createRenderCustomHeader } from '../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../utils/datePickerUtils';
import '../../../styles/datepicker.css'

import { locale as primeLocale, addLocale } from 'primereact/api'
import { useFiltrosStore } from "../../../lib/store/filtros.store";
import { jwtDecode } from 'jwt-decode';
import { Dropdown } from "primereact/dropdown";
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../utils/bitacora';
// 📌 Registrar la localización en español para DatePicker
registerLocale('es', es);
setDefaultLocale('es'); //

const paradasNoAutorizadasFiltros = ({ onGenerateReport, imprimir }) => {

    const [grupos, setGrupos] = useState([]);
    const [selectedGrupo, setSelectedGrupo] = useState(null);

    const vehiculos = useFiltrosStore((state) => state.vehiculos)
    const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
    const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
    const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)

    const [selectedVehicle, setSelectedVehicle] = useState([]); // Almacena IDs (strings)
    const [selectedAlerts, setSelectedAlerts] = useState([]);
    const [open, setOpen] = useState(true);
    //const [vehiculos, setVehiculos] = useState([]);
    const [tipoAlertas, setTipoAlertas] = useState([]);

    //estados para filtro omisiones
    const [selectedTiempo, setSelectedTiempo] = useState(0);
    const [btnFiltroActivo, setBtnFiltroActivo] = useState(false);

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);
    const [dateRangeWarning, setDateRangeWarning] = useState("");
    const [dateRangeInvalid, setDateRangeInvalid] = useState(false);
    // Validar rango de fechas: máximo 5 días
    useEffect(() => {
        if (!startDate || !endDate) return;
        const diffMs = endDate - startDate;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        if (diffDays > 15) {
            setDateRangeWarning("El rango máximo permitido es de 15 días.");
            setDateRangeInvalid(true);
            // import('sweetalert2').then(Swal => {
            //     Swal.default.fire({
            //         icon: 'warning',
            //         title: 'Rango de fechas inválido',
            //         text: 'El rango máximo permitido es de 5 días.',
            //     });
            // });
        } else {
            setDateRangeWarning("");
            setDateRangeInvalid(false);
        }
    }, [startDate, endDate]);

    const loadGrupos = async () => {
        try {
            const response = await GruposService.getGrupos();
            if (response && response.statusCode === 200) {

                const _grupos = sortBy(response.data, 'nombre')

                const gruposData = _grupos.map((grupo) => ({
                    value: grupo.uid_grupo,
                    label: `${grupo.nombre}`,
                    uid_grupo: grupo.uid_grupo
                }));

                //setSelectedGrupo(gruposData)
                setGrupos(gruposData);
            }
        } catch (error) {
            console.error("Error cargando los grupos:", error);
        }
    };

    // 🚗 Cargar Vehículos
    const loadVehiculos = async () => {
        try {
            const response = await VehiculosService.getVehiculos();
            if (response && response.statusCode === 200) {
                //id_analitic != null

                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() })

                const vehiculosData = _vehiculos
                    .filter(vehiculo => vehiculo.id_analitic !== null)
                    .map(vehiculo => ({
                        value: vehiculo.uid_vehiculo ?? "",
                        id_analitic: vehiculo.id_analitic,
                        label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
                        uid_grupo: vehiculo.uid_grupo,
                        no_economico: vehiculo.no_economico,
                        alias: `${vehiculo.alias}`,
                        tipo_vehiculo: vehiculo.tipo_vehiculo || 'sedan',
                        color_vehiculo: vehiculo.color_vehiculo || '#000000'
                    }));



                setVehiculos(vehiculosData);
                setVehiculosFiltrados([])
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    useEffect(() => {
        // Verificar estructura de los vehículos filtrados
        if (vehiculosFiltrado && vehiculosFiltrado.length > 0) {
            console.log("Estructura vehículo:", vehiculosFiltrado[0]);
        }
    }, [vehiculosFiltrado]);

    // Listado TipoAlerta para Omisiones
    const loadTipoAlertaOmisiones = async () => {
        try {
            const response = await AlertaService.getTipoAlertaOmisiones();
            if (response && response.statusCode === 200) {
                const alertas = response.data
                    .filter(alerta => ["6091ba3e662e2b2e74500a43", "6761c5a6c3e4e161ae6ea34b"].includes(alerta.id)) // solo mostramos detenido y apagado de motor
                    .map(alerta => ({
                        value: alerta.id,
                        label: `${alerta.nombre}`
                    }));


                setTipoAlertas(alertas);
            }
        } catch (error) {
            console.error("Error cargando tipo alertas Omsiones:", error);
        }
    };

    useEffect(() => {
        loadGrupos()
        loadVehiculos();
        loadTipoAlertaOmisiones();
    }, []);


    useEffect(() => {
        if (selectedVehicle.length > 0) {
            setBtnFiltroActivo(true)
        } else {

            setBtnFiltroActivo(false)
        }
    }, [selectedVehicle])

    useEffect(() => {

        setVehiculosFiltrados(selectedGrupo || [])
    }, [selectedGrupo]);

    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    // const handleGenerate = () => {
    //     setOpen(false);
    //     // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
    //     /*const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
    //     const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
    //     const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC*/

    //     const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
    //     const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")

    //     onGenerateReport({
    //         fecha_inicio: _fechaInicio,
    //         fecha_fin: _fechaFin,
    //         uids_vehiculo: selectedVehicle && selectedVehicle.length > 0 ? selectedVehicle.map(v => v.value) : [],
    //         uids_evento: selectedAlerts && selectedAlerts.value ? [selectedAlerts.value] : ["6091ba3e662e2b2e74500a43", "6761c5a6c3e4e161ae6ea34b"], // solo para el caso de omisiones
    //         tiempo: selectedTiempo ?? 0,
    //     });
    // };

    const handleGenerate = () => {
        // Ajustar fechas al formato correcto
        const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss");
        const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss");

        const decoded = jwtDecode(localStorage.getItem('token'));

        // selectedVehicle contiene uid_vehiculo (strings únicos)
        // Mapear a id_analitic que es lo que necesita el endpoint
        const vehiculosSeleccionados = vehiculos.filter(v => selectedVehicle.includes(v.value));
        const vehiculosIds = vehiculosSeleccionados
            .map(v => v.id_analitic)
            .filter(id => id !== null && id !== '0');

        if (vehiculosIds.length === 0) {
            console.warn("No hay vehículos válidos seleccionados");
            return;
        }
        let vehiculosList = vehiculosSeleccionados;
        generarBitacoraReporte(AccionBitacora.Generar);
        onGenerateReport({
            fecha_inicio: _fechaInicio,
            fecha_fin: _fechaFin,
            uids_vehiculo: vehiculosIds,
            uids_evento: selectedAlerts.length > 0
                ? [selectedAlerts]
                : ["6091ba3e662e2b2e74500a43", "6761c5a6c3e4e161ae6ea34b"],
            tiempo: parseInt(selectedTiempo || 0, 10),

            // Campos adicionales para el paginado
            empresaUid: decoded.uid_empresa,
            uid_usuario: decoded.uid_usuario,
            perfil: 1,
            count: true,
            limit: 10000,
            page: 1,
            vehiculos: vehiculosList
        });
    };

    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Paradas no autorizadas', observacion: 'Paradas no autorizadas', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = (grupos || []).filter(w => (selectedGrupo || []).includes(w.value));
            let dataVehiculos = (vehiculos || []).filter(w => (selectedVehicle || []).includes(w.value));
            let dataAlertas = [];
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
        }
        guardarBitacora({
            categoria: 'Reporte Paradas no autorizadas',
            observacion: generarObservacion(
                'Paradas no autorizadas',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                }
            ),
            tipoAccion: accion
        });
    }
    //     const handleGenerate = () => {
    //     // Ajustar fechas al formato correcto
    //     const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss");
    //     const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss");

    //      const decoded = jwtDecode(localStorage.getItem('token'));

    //     // Verificar la estructura de selectedVehicle para debugging
    //     console.log("Selected Vehicles:", selectedVehicle);

    //     // Filtrar elementos nulos o indefinidos antes de mapear
    //     const vehiculosIds = selectedVehicle && selectedVehicle.length > 0 
    //         ? selectedVehicle
    //             .filter(v => v && v.value) // Asegurar que el objeto y su propiedad value existen
    //             .map(v => v.value) 
    //         : [];

    //     console.log("Vehicle IDs after mapping:", vehiculosIds);

    //     onGenerateReport({
    //         fecha_inicio: _fechaInicio,
    //         fecha_fin: _fechaFin,
    //         uids_vehiculo: vehiculosIds,
    //         uids_evento: selectedAlerts && selectedAlerts.value 
    //             ? [selectedAlerts.value] 
    //             : ["6091ba3e662e2b2e74500a43", "6761c5a6c3e4e161ae6ea34b"], // Detenido y Apagado
    //         tiempo: selectedTiempo ?? 0,

    //         // Campos adicionales para el paginado
    //         empresaUid: decoded.uid_empresa,
    //         uid_usuario: decoded.uid_usuario,
    //         perfil: 1,
    //         count: true,
    //         limit: 10000,
    //     });
    // };

    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {

        const allSelected = selected.some(option => option.value === 'all');

        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) { // 🔹 Se suma 1 por la opción "Seleccionar todos"
                setSelected([]); // 🔹 Deseleccionar todo correctamente
            } else {
                setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
            }
        } else {
            setSelected(selected);
        }
    };

    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);
    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );

    return (
        <div>
            <div id="filter-collapse">
                {dateRangeWarning && (
                    <Col xs={12}>
                        <div className="alert alert-warning py-2 my-2">
                            {dateRangeWarning}
                        </div>
                    </Col>
                )}

                <Row className='mb-3'>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Desde</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderIniHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                                minTime={new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)}
                                maxTime={
                                    (startDate.getDate() === now.getDate() && startDate.getMonth() === now.getMonth() && startDate.getFullYear() === now.getFullYear())
                                        ? now
                                        : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59)
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Hasta</Form.Label>
                            <DatePicker
                                selected={endDate}
                                minDate={startDate}
                                minTime={
                                    endDate.getDate() === startDate.getDate() && endDate.getMonth() === startDate.getMonth() && endDate.getFullYear() === startDate.getFullYear()
                                        ? startDate
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                                }
                                maxTime={
                                    (endDate.getDate() === now.getDate() && endDate.getMonth() === now.getMonth() && endDate.getFullYear() === now.getFullYear())
                                        ? now
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)
                                }
                                onChange={handleEndDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderEndHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4} className="d-flex flex-column">
                        <label>Grupo</label>
                        <MultiSelect
                            className="multiselect-ul w-full md:w-20rem"
                            value={selectedGrupo}
                            onChange={(e) => {
                                setSelectedGrupo(e.value);
                                setSelectedVehicle([]);
                            }}
                            options={grupos}
                            optionLabel="label"
                            filter
                            placeholder="Seleccione un grupo"
                            maxSelectedLabels={2}
                            selectedItemsLabel={`${(selectedGrupo || []).length} grupos seleccionados`}
                            appendTo={document.body}
                        />
                    </Col>
                    <Col md={3} xs={4} className="d-flex flex-column">
                        <label>Vehículos</label>
                        <MultiSelect
                            className="multiselect-ul w-full md:w-20rem"
                            value={selectedVehicle}
                            onChange={(e) => {
                                setSelectedVehicle(e.value);
                            }}
                            options={vehiculosFiltrado}
                            optionLabel="label"
                            optionValue="value"
                            filter
                            placeholder="Seleccione un vehículo"
                            maxSelectedLabels={2}
                            emptyFilterMessage="No se encontraron vehículos"
                            emptyMessage="No hay vehículos disponibles"
                            selectedItemsLabel={`${(selectedVehicle || []).length} vehículos seleccionados`}
                            appendTo={document.body}
                        />
                    </Col>
                    {/**
                     * <Col md={2} xs={4}>
                        <Form.Group>
                            <Form.Label>Vehículos</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                options={[
                                    ...(selectedVehicle.length !== vehiculos.length
                                        ? [{ value: 'all', label: 'Seleccionar todos' }]
                                        : [{ value: 'all', label: 'Deseleccionar todos' }]
                                    ),
                                    ...vehiculos
                                ]}
                                classNamePrefix="react-select"
                                value={selectedVehicle}
                                onChange={(selected) => handleSelectChange(selected, vehiculos, setSelectedVehicle)}
                                isMulti
                                styles={customStyles}
                            />
                        </Form.Group>
                    </Col>
                     */}
                </Row>

                <Row>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Tipo Evento</Form.Label>

                            <Dropdown
                                value={selectedAlerts}
                                options={[
                                    ...tipoAlertas
                                ]}
                                onChange={(selected) => {
                                    setSelectedAlerts(selected.value);
                                }}
                                optionLabel="label"
                                placeholder="Seleccione un tipo evento..."
                                className="w-full md:w-14rem"
                                checkmark={true}
                                highlightOnSelect={false}
                                styles={customStyles}
                                filter
                                appendTo={document.body}
                            >

                            </Dropdown>

                            {/* <Select
                                closeMenuOnSelect={true}
                                options={[
                                    ...tipoAlertas
                                ]}
                                classNamePrefix="react-select"
                                value={selectedAlerts}
                                onChange={(selected) => {
                                    console.log("Valor seleccionado Select:", selected);
                                    setSelectedAlerts(selected)
                                }}
                                styles={customStyles}
                            /> */}
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Tiempo</Form.Label>
                            <Form.Control
                                value={selectedTiempo || ""}  // Usar string vacío cuando es 0
                                onChange={e => {
                                    // Convertir a número y asegurar valor mínimo de 0
                                    const newValue = e.target.value === "" ? 0 : Math.max(0, parseInt(e.target.value, 10) || 0);
                                    setSelectedTiempo(newValue);
                                }}
                                type="number"
                                min="0"
                            />
                        </Form.Group>
                        {/* <Form.Group><Form.Label>Tiempo</Form.Label><Form.Control value={selectedTiempo} onChange={e => setSelectedTiempo(e.target.value)} type="number" /></Form.Group> */}
                    </Col>
                    <Col md={2} xs={4}>
                        <div className="d-flex mt-4">
                            <Button variant="primary" className="w-100" onClick={handleGenerate} disabled={!btnFiltroActivo || dateRangeInvalid}>
                                Generar
                            </Button>
                            {/* {dateRangeWarning && (
                                <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>{dateRangeWarning}</div>
                            )} */}
                        </div>
                    </Col>
                    <Col md={2} xs={4}>
                        <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default paradasNoAutorizadasFiltros;